import React from 'react'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Box from '@material-ui/core/Box'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
// @src imports
import { useAccount, useActions, useState } from 'src/hooks'
import { LEGACY_SITE_URL } from 'src/app/api'
import { ProfileAvatar } from 'src/chrome'

import styles from './accountDropdown.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

interface AccountDropdownProps {}

const AccountDropdown: React.FC<AccountDropdownProps> = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const account = useAccount()
  const actions = useActions()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget)

  const handleClose = () => setAnchorEl(null)

  return (
    <Box
      className={styles.profileActions}
      display="flex"
      p={1}
      alignItems="center"
    >
      <Box p={1}>
        <ProfileAvatar
          account={account}
          size={50}
          isEditable={false}
          style={{ color: 'white' }}
        />
      </Box>
      <Box p={1} flexGrow={1}>
        <Button
          id="account_drop_down_btn"
          aria-controls="drop-down-menu"
          aria-haspopup="true"
          onClick={handleClick}
          endIcon={<ArrowDropDownIcon fontSize={'small'} />}
          style={{ fontSize: 'initial', padding: '0 16px' }}
        >
          <Text type="body">{`Hello ${account.firstName}`}</Text>
        </Button>
        <Menu
          id="drop-down-menu"
          anchorEl={anchorEl}
          keepMounted={true}
          className={styles.dropDown}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={() => {}}
            style={{ fontSize: 'initial', padding: '3px 16px' }}
          >
            <Text type="body">{`Account #${account.genealogyId}`}</Text>
          </MenuItem>
          {!account.isNewUser && (
            <MenuItem
              onClick={() =>
                (window.location.href = `${LEGACY_SITE_URL}/main-menu/?access_token=${account.token}`)
              }
              style={{ fontSize: 'initial', padding: '3px 16px' }}
            >
              <Text type="body">{'Legacy Site'}</Text>
            </MenuItem>
          )}
          <MenuItem
            onClick={() =>
              (window.location.href = `${LEGACY_SITE_URL}/resources/`)
            }
            style={{ fontSize: 'initial', padding: '3px 16px' }}
          >
            <Text type="body">{'Resource Center'}</Text>
          </MenuItem>
          <MenuItem
            id="logout_btn"
            onClick={actions.logout}
            style={{ fontSize: 'initial', padding: '3px 16px' }}
          >
            <Text type="body">{'Logout'}</Text>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
}

export default AccountDropdown
